const data = [
    {
      id: 'NaNNA463undefined',
      name: 'Väinö Perko',
      age: 21,
      image: 'https://randomuser.me/api/portraits/men/13.jpg',
      email: 'vaino.perko@example.com',
    },
    {
      id: '294562198',
      name: 'Mihailo Jović',
      age: 47,
      image: 'https://randomuser.me/api/portraits/men/55.jpg',
      email: 'mihailo.jovic@example.com',
    },
    {
      id: 'NaNNA281undefined',
      name: 'Nooa Harju',
      age: 57,
      image: 'https://randomuser.me/api/portraits/men/46.jpg',
      email: 'nooa.harju@example.com',
    },
    {
      id: 'ES 75 36 40 Q',
      name: 'Ivan Medina',
      age: 27,
      image: 'https://randomuser.me/api/portraits/men/36.jpg',
      email: 'ivan.medina@example.com',
    },
    {
      id: 'BT 32 99 37 P',
      name: 'Tracey Hoffman',
      age: 69,
      image: 'https://randomuser.me/api/portraits/women/80.jpg',
      email: 'tracey.hoffman@example.com',
    },
    {
      id: 'BB 58 36 13 U',
      name: 'Emily Cunningham',
      age: 64,
      image: 'https://randomuser.me/api/portraits/women/50.jpg',
      email: 'emily.cunning@example.com',
    },
    {
      id: '059737189',
      name: 'William Claire',
      age: 62,
      image: 'https://randomuser.me/api/portraits/men/57.jpg',
      email: 'william.claire@example.com',
    },
    {
      id: '2920214291853 13',
      name: 'Diane Martinez',
      age: 30,
      image: 'https://randomuser.me/api/portraits/women/51.jpg',
      email: 'diane.martinez@example.com',
    },
    {
      id: 'Elif',
      name: 'Elif Tokatlıoğlu',
      age: 36,
      image: 'https://randomuser.me/api/portraits/women/4.jpg',
      email: 'elif.tokatlioglu@example.com',
    },
    {
      id: 'EA 05 60 05 K',
      name: 'Heather Byrd',
      age: 37,
      image: 'https://randomuser.me/api/portraits/women/71.jpg',
      email: 'heather.byrd@example.com',
    },
    {
      id: '219342235',
      name: 'Maya Williams',
      age: 29,
      image: 'https://randomuser.me/api/portraits/women/40.jpg',
      email: 'maya.williams@example.com',
    },
    {
      id: 'NaNNA549undefined',
      name: 'Luukas Manni',
      age: 34,
      image: 'https://randomuser.me/api/portraits/men/40.jpg',
      email: 'luukas.manni@example.com',
    },
    {
      id: '75773788',
      name: 'Samir Karssen',
      age: 62,
      image: 'https://randomuser.me/api/portraits/men/82.jpg',
      email: 'samir.karssen@example.com',
    },
    {
      id: '786-60-5441',
      name: 'Tracy Reid',
      age: 22,
      image: 'https://randomuser.me/api/portraits/men/97.jpg',
      email: 'tracy.reid@example.com',
    },
    {
      id: '2574875T',
      name: 'Jacob Neal',
      age: 57,
      image: 'https://randomuser.me/api/portraits/men/58.jpg',
      email: 'jacob.neal@example.com',
    },
    {
      id: 'drskm',
      name: 'درسا كامياران',
      age: 27,
      image: 'https://randomuser.me/api/portraits/women/96.jpg',
      email: 'drs.kmyrn@example.com',
    },
    {
      id: 'zhoze',
      name: 'Zhozefina Ohrimovich',
      age: 54,
      image: 'https://randomuser.me/api/portraits/women/58.jpg',
      email: 'zhozefina.ohr@example.com',
    },
    {
      id: '3793794T',
      name: 'Victoria Butler',
      age: 62,
      image: 'https://randomuser.me/api/portraits/women/17.jpg',
      email: 'victoria.butler@example.com',
    },
    {
      id: '9143077T',
      name: 'Rich Clark',
      age: 51,
      image: 'https://randomuser.me/api/portraits/men/42.jpg',
      email: 'rich.clark@example.com',
    },
    {
      id: 'SC 18 90 45 Z',
      name: 'Curtis Gibson',
      age: 28,
      image: 'https://randomuser.me/api/portraits/men/55.jpg',
      email: 'curtis.gibson@example.com',
    },
  ];
  
  export default data;